// Note: \ufeff is a zero width no-break space (https://www.compart.com/en/unicode/U+FEFF) and is inserted by Quill
//       for Embed blots
const customVariableRegex = /%{.+?}/g;
const customVariableReplace =
  '<span class="custom-variable-blot" data-value="$&">\ufeff<span contenteditable="false">$&</span>\ufeff</span>';
const customVariableBlotRegex =
  /<span class="custom-variable-blot" data-value="(.+?)">(\ufeff)?<span contenteditable="false">\1<\/span>(\ufeff)?<\/span>/g;
const customVariableBlotReplace = '$1';

export const wrapCustomVariables = (content?: string | null) => {
  if (!content) {
    return content;
  }

  return content.replace(customVariableRegex, customVariableReplace);
};

export const unwrapCustomVariables = (content?: string | null) => {
  if (!content) {
    return content;
  }

  return content.replace(customVariableBlotRegex, customVariableBlotReplace);
};
